import React, {Component} from "react";
import {injectIntl} from "react-intl";
import {connect} from "react-redux";
import LoadingIndicator from "../../common/loading/LoadingIndicator";
import RentalVehicle from "./RentalVehicle";
import RentalAssignModal from "../rentalassign/RentalAssignModal";
import Constants from "../../../services/Constants";
import OtherSolution from "./OtherSolution";
import Intervention from "../../../services/Intervention";
import {Col, Row} from "antd";

class MobilitySolution extends Component {

  constructor(props) {
    super(props);
    this.state = {
      showOtherMobilityModal: false
    }
  }

  componentDidMount() {
    this.props.dispatchFetchMobility();
    const {intervention: {journey: {rentalContract} = {}}} = this.props;
    if (rentalContract) {
      this.props.dispatchFetchRentalReporting(rentalContract.id);
    }
  }

  componentWillReceiveProps(nextProps) {

  }

  onShowAssignModal = () => {
    this.props.showAssignModal();
  };

  onHideAssignModal = () => {
    this.props.hideAssignModal();
  };

  onShowOtherMobilityModal = () => {
    this.setState({showOtherMobilityModal: true})
  };

  onHideOtherMobilityModal = () => {
    this.setState({showOtherMobilityModal: false})
  };

  onMobilityChange = (mobility) => {
    this.setState({showOtherMobilityModal: false});
    this.props.onSelect(mobility);
  };

  computeAvailableMobility = () => {
    const {fetchMobility: {mobility: {categoryMobility = {}, otherMobility = {}, serviceMobility = {}, extraMobility = []} = {}}} = this.props;
    const availableMobilitySolutions = [];
    Object.keys(categoryMobility).forEach(key => categoryMobility[key].active && availableMobilitySolutions.push(categoryMobility[key]));
    Object.keys(otherMobility).forEach(key => otherMobility[key].active && availableMobilitySolutions.push(otherMobility[key]));
    Object.keys(serviceMobility).forEach(key => serviceMobility[key].active && availableMobilitySolutions.push(serviceMobility[key]));
    availableMobilitySolutions.push(...extraMobility);
    return availableMobilitySolutions;
  };

  computeMobilityName = (selectedMobility) => {
    const {intl, intl: {formatMessage}, mobility} = this.props;
    if (mobility.startsWith("category")) {
      return {
        mobilityTitle: formatMessage({id: `mobility.${mobility}`}),
        mobilityDescription: formatMessage({id: 'mobility.rental-car'})
      }
    }
    return {
      mobilityTitle: formatMessage({id: 'vehicle.category'}) + ': ' + (selectedMobility && selectedMobility.label ? selectedMobility.label[intl.locale] : formatMessage({id: `mobility.${mobility}`})),
      mobilityDescription: selectedMobility && selectedMobility.description ? selectedMobility.description[intl.locale] : undefined
    };
  };

  renderMobilityActions = (selectedMobility, availableMobility) => {
    const {intl: {formatMessage}, fetchRentalReporting: {reporting: {deliveryReport = {}} = {}}, intervention, intervention: {journey: {rentalVehicle}}, mobility, pristine} = this.props;
    const {showOtherMobilityModal} = this.state;

    const mobilityIsAssignable = !rentalVehicle && selectedMobility && Constants.MOBILITY_VEHICLES.includes(selectedMobility.name);
    // If there is a delivery report, then it is not possible to change the mobility solution anymore
    const canChangeSolution = !deliveryReport.id;

    return (
      <div>
        <Row type={"flex"} gutter={16}>
          {canChangeSolution &&
            <Col>
              <button onClick={this.onShowOtherMobilityModal} type="primary" className="btn btn-sm btn-o-secondary mr-2 mt-1">
                {formatMessage({id: 'appointment.detail.mobility.other-mobility'})}
              </button>
            </Col>
          }

          {mobilityIsAssignable && Intervention.isConfirmed(intervention) &&
            <Col>
              <button onClick={this.onShowAssignModal} type="primary" className="btn btn-sm btn-primary mt-1" disabled={pristine}>
                {formatMessage({id: 'appointment.detail.mobility.assign-mobility'})}
              </button>
            </Col>
          }
        </Row>
        <OtherSolution visible={showOtherMobilityModal} onModalClose={this.onHideOtherMobilityModal} onChange={this.onMobilityChange} mobility={mobility} availableMobilities={availableMobility}/>
      </div>
    )
  };

  render() {
    const {intl: {formatMessage}, canWrite, selected, fetchMobility, mobility} = this.props;
    const {intervention, intervention: {journey: {id, uuid, properties, rentalVehicle} = {}}, assignRentalVehicle: {showModal}} = this.props;

    const selectedCss = selected === true ? undefined : "choice-card--unselected";

    const availableMobility = this.computeAvailableMobility();
    // TODO do not display this if no category
    const defaultMobility = ["wait", "own"].includes(mobility) ? (availableMobility && availableMobility.length > 0) ? availableMobility[0].name : 'category1' : properties.mobility.mobility.name;

    if (!selected) {
      return (
        <div className="col-sm-6 col-lg-6">
          <div className={["choice-card", selectedCss].join(' ')} onClick={() => this.props.onSelect(defaultMobility)}>
            <header className="choice-card__header">
              <h4 className="choice-card__title">{formatMessage({id: 'appointment.detail.mobility.mobility-solution.title'})}</h4>
            </header>
            <div className="choice-card__body">
            </div>
          </div>
        </div>
      )
    }

    if (!fetchMobility || !fetchMobility.mobility) {
      return <LoadingIndicator/>
    }

    const selectedMobility = availableMobility.find(s => s.name === mobility);
    const {mobilityDescription, mobilityTitle} = this.computeMobilityName(selectedMobility);

    const hasMobilityVehicle = Constants.MOBILITY_VEHICLES.includes(mobility) && rentalVehicle;
    return (
      <div className="col-sm-6 col-lg-6">
        <div className={["choice-card", selectedCss].join(' ')}>
          <header className="choice-card__header">
            <h4 className="choice-card__title">{formatMessage({id: 'appointment.detail.mobility.mobility-solution.title'})}</h4>
          </header>
          <div className="choice-card__body mobility">
            <div className="choice-card__subtitle">
              <div>{mobilityTitle}</div>
              <div className="txt-muted">{mobilityDescription}</div>
              <br/>
            </div>
            {!selectedMobility &&
              <div className={"txt-error"}>{formatMessage({id: 'appointment.detail.mobility.mobility-solution.deprecated'})}</div>
            }

            {selectedMobility && hasMobilityVehicle &&
              <RentalVehicle rentalVehicle={rentalVehicle} intervention={intervention} canWrite={canWrite}/>
            }

            {canWrite &&
              this.renderMobilityActions(selectedMobility, availableMobility)
            }

          </div>
        </div>

        <RentalAssignModal visible={showModal} onModalClose={this.onHideAssignModal} intervention={intervention}/>
      </div>
    )
  }
}

const mapStateToProps = state => ({
  fetchMobility: state.fetchMobility,
  fetchRentalReporting: state.fetchRentalReporting,
  assignRentalVehicle: state.assignRentalVehicle,
});

const mapDispatchToProps = dispatch => ({
  dispatchFetchMobility: () => dispatch({type: 'FETCH_MOBILITY.REQUEST'}),
  dispatchFetchRentalReporting: rentalDetailsId => dispatch({type: 'FETCH_RENTAL_REPORTING.REQUEST', rentalDetailsId}),
  showAssignModal: () => dispatch({type: 'SHOW_ASSIGN_MODAL'}),
  hideAssignModal: () => dispatch({type: 'HIDE_ASSIGN_MODAL'}),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(injectIntl(MobilitySolution))
